import moment from 'moment';
import FormMixin from '@/mixins/formvalid'

export default {
  mixins: [FormMixin],
  props: ['dialog', 'form'],
  components: {},
  data () {
    return {
      menu_time: false,
      menu_date: false,
      dateFormatted: null,
      users: [],
      selectedUser: null
    }
  },
  methods: {
    formatDate (date) {
      if (!date) {
        return null
      }
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    formatDates (dates) {
      if (!dates) {
        return null
      }
      return dates.map((date) => {
        var [year, month, day] = date.split('-');
        return `${day}/${month}/${year}`
      })
    },
    unformatDate (date) {
      if (!date) {
        return null
      }
      const [day, month, year] = date.split('/')
      return `${year}-${month}-${day}`
    },
    save () {
      if (this.$refs.form.validate()) {
        console.log('selectedUser', this.selectedUser);
        this.$emit('save');
      }
    },
    update () {
      if (this.$refs.form.validate()) {
        this.$emit('update');
      }
    },
    close () {
      this.$emit('close');
    },
    reset () {
      this.dateFormatted = null;
    },
    onChange (e) {},
    getUsers () {
      this.$http.post('service/user/findByRoles', {roles:'"admin", "dispatch"'})
      .then((response) => {
        // console.log(response)
        this.users = response.data || [];
      })
    }
  },
  filters: {
  },
  watch: {
    dialog (value) {
      this.getUsers();
    }
  },
  created () {}
}
